import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54281dce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h3" }, "Claim BLUES", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-s4 caption" }, " You need to have some amount of milkADA in your wallet for the transaction. ", -1))
const _hoisted_4 = {
  key: 1,
  class: "flex text-info mt-s4"
}
const _hoisted_5 = { class: "text-sm ml-s1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" There is nothing to claim right now.")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { getExplorerLink } from '@/composables/core/useExplorerLink';
import { ToastMessageOptions } from 'primevue/toast';
import { useToast } from 'primevue/usetoast';
import ClaimWallet from '@/views/vesting/claimForm/ClaimWallet.vue';
import Icon from '@/components/Icon.vue';
import { useVesting } from '@/composables/core/useVesting';
import { computed, ref } from 'vue';
import ClaimableAmount from '@/views/vesting/claimForm/ClaimableAmount.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toast = useToast();
const {
  claimableAmountFormatted,
  vestingStateIsReady,
  vestingInfo,
  startDate,
  startDateFormatted,
  isNotListed,
  claim,
  updateVesting,
} = useVesting();

const isTimeToVesting = computed(
  () => !startDate.value || startDate.value < new Date(),
);

const txIsInProgress = ref(false);
const canWithdraw = computed(() => {
  if (!vestingInfo.value) {
    return false;
  }

  return vestingInfo.value.claimableAmount.weiAmount.gt(0);
});

const showInfo = (txHash: string) => {
  toast.add({
    severity: 'info',
    summary: 'In progress',
    detail: `Your claim for ${claimableAmountFormatted.value} BLUES has been submitted.`,
    explorerLink: getExplorerLink(txHash, 'tx'),
  } as unknown as ToastMessageOptions);
};
const showSuccess = (txHash: string) => {
  toast.add({
    severity: 'success',
    summary: 'Done',
    detail: `Cheers!<br>Your claim for ${claimableAmountFormatted.value} BLUES has been completed.\n`,
    explorerLink: getExplorerLink(txHash, 'tx'),
    life: 6000,
  } as unknown as ToastMessageOptions);
};
const showError = () => {
  toast.add({
    severity: 'danger',
    summary: 'Error',
    detail: 'Sorry, the transaction failed. Please send your submission again.',
    life: 5000,
  } as ToastMessageOptions);
};

const onClaim = async () => {
  txIsInProgress.value = true;
  let txHash = '';
  try {
    await claim(hash => {
      txHash = hash;
      showInfo(txHash);
    });
    toast.removeAllGroups();
    showSuccess(txHash);
  } catch {
    showError();
  }
  txIsInProgress.value = false;
  updateVesting();
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(ClaimWallet),
    (_unref(isTimeToVesting))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(ClaimableAmount),
          _hoisted_3,
          _createVNode(_component_Button, {
            disabled: 
          _unref(isNotListed) || !_unref(vestingStateIsReady) || txIsInProgress.value || !_unref(canWithdraw)
        ,
            class: "button-card-form w-full mt-s4",
            label: "Claim",
            onClick: onClaim
          }, null, 8, ["disabled"])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(Icon, {
            name: "status",
            size: "20"
          }),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createTextVNode(" Your claim period start " + _toDisplayString(_unref(startDateFormatted)), 1)
          ])
        ]))
  ]))
}
}

})